import { render, staticRenderFns } from "./mailbox-verification-popup-email-viewer.vue?vue&type=template&id=4ba11a7a&"
import script from "./mailbox-verification-popup-email-viewer.vue?vue&type=script&lang=ts&"
export * from "./mailbox-verification-popup-email-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-verification-popup-email-viewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports